import {tl} from "framework/utils/Translator"

import HotelIcon from "@material-ui/icons/LocationCity"
import CheckIcon from "@material-ui/icons/CheckCircle"
import CancelIcon from "@material-ui/icons/Cancel"
import SalesOrderIcon from "@material-ui/icons/Assignment"
import BedIcon from "@material-ui/icons/Hotel"
import CategoryIcon from "@material-ui/icons/Category"
import ListIcon from "@material-ui/icons/List"
import PersonIcon from "@material-ui/icons/Person"
import ExcelIcon from "@material-ui/icons/GridOn"

import RoomActivity from "./activities/RoomActivity"
import RoomCategoryActivity from "./activities/RoomCategoryActivity"
import RoomFacilityActivity from "./activities/ItemSpecActivity"
import OnlineBookingActivity from "./activities/OnlineBookingActivity"
import OnlineBookingFinishedActivity from "./activities/OnlineBookingFinishedActivity"
import OnlineBookingCancelled from "./activities/OnlineBookingCancelledActivity"
import CustomerActivity from "./activities/CustomerActivity"
import SalesOrderReportActivity from "./activities/SalesOrderReportActivity"

const Routes = [
    {
        collapse	: true,
	    name		: tl("Hospitality"),
	    menu		: "HSP",
	    icon 		: HotelIcon,
	    state		: "HSP",
	    views		: [
            {
                path		: "/hospitality-online-booking/:id?",
                name		: tl("OnlineBooking"),
                menu		: "HSPOLBK",
                icon 		: SalesOrderIcon,
                component 	: OnlineBookingActivity,
                layout		: "/admin"
            },
             {
                path		: "/hospitality-online-booking-finished/:id?",
                name		: tl("CheckedOut"),
                menu		: "HSPBCO",
                icon 		: CheckIcon,
                component 	: OnlineBookingFinishedActivity,
                layout		: "/admin"
            },
            {
                path		: "/hospitality-online-booking-cancelled/:id?",
                name		: tl("CancelledBooking"),
                menu		: "HSPBCC",
                icon 		: CancelIcon,
                component 	: OnlineBookingCancelled,
                layout		: "/admin"
            },
            {
                path		: "/hospitality-customer/:id?",
                name		: tl("Customer"),
                menu		: "HSPGST",
                icon 		: PersonIcon,
                component 	: CustomerActivity,
                layout		: "/admin"
            },
        ]
    },
    {
        collapse	: true,
	    name		: tl("HospitalityReport"),
	    menu		: "HSPRPT",
	    icon 		: ExcelIcon,
	    state		: "HSPRPT",
	    views		:[
            {
                path		: "/bakery-sales-report",
                name		: tl("SalesReport"),
                menu		: "HSPSLSRPT",
                icon 		: ExcelIcon,
                component 	: SalesOrderReportActivity,
                layout		: "/admin"
            },
        ]
    },
    {
        collapse	: true,
	    name		: tl("HospitalityConfiguration"),
	    menu		: "HSPCONF",
	    icon 		: HotelIcon,
	    state		: "HSPCONF",
	    views		:[
            {
                path		: "/room/:id?",
                name		: tl("Room"),
                menu		: "HSPCONFRM",
                icon 		: BedIcon,
                component 	: RoomActivity,
                layout		: "/admin"
            },
            {
                path		: "/room-category/:id?",
                name		: tl("RoomCategory"), 
                menu		: "HSPCONFRMC",
                icon 		: CategoryIcon,
                component 	: RoomCategoryActivity,
                layout		: "/admin"
            },
            {
                path		: "/item-spec/:id?",
                name		: tl("ItemSpec"), 
                menu		: "HSPCONFRMSPC", 
                icon 		: ListIcon,
                component 	: RoomFacilityActivity,
                layout		: "/admin"
            },
        ]
    },
]

export default Routes